import { CHAT_EVENTS } from "../../constants/chat";
import { SCENE_EVENTS } from "../MVC/Model";

export class TourStartMenu {
  constructor({ model }) {
    this.model = model;
    this.container = $('#tourStartMenu');
    this.opened = false;
    this.render();
    this.close();

    this.container.on('click', '.tour-start-menu__item', (e) => {
      e.stopPropagation();
      const visibility = $(e.currentTarget).attr('data-visibility');
      this.close();
      if (!visibility) {
        return;
      }
      this.model.startTourFromMenu(visibility);
    });

    const close = () => this.close();
    $("#css3d").on("click", close);
    $("#tuneMenu").on("click", close);
    $("#people-list-icon-button").on("click", close);
    $("#burger-menu").on("click", close);
    model.addEventListener(CHAT_EVENTS.OPEN, close);
    model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, close);
  }

  toggle() {
    if (this.opened) {
      this.close();
      return;
    }
    this.open();
  }

  open() {
    this.render();
    this.opened = true;
    this.container.addClass('is-active');
    const button = document.getElementById('guideButton');
    if (button) {
      const rect = button.getBoundingClientRect();
      const menuWidth = this.container.outerWidth() || 180;
      const left = Math.max(8, Math.min(rect.left, window.innerWidth - menuWidth - 8));
      this.container.css('left', `${left}px`);
    }
    if (typeof multiLanguagesController !== 'undefined') {
      multiLanguagesController.renderLanguage();
    }
  }

  close() {
    this.opened = false;
    this.container.removeClass('is-active');
  }

  render() {
    this.container.html(`
      <li class="tune-menu-title tour-start-menu__title">
        <span data-lang="start-tour-title">${$trans('start-tour-title')}</span>
      </li>
      <li class="clickable tour-start-menu__item" data-visibility="public">
        <span data-lang="start-tour-visibility-public">${$trans('start-tour-visibility-public')}</span>
      </li>
      <li class="clickable tour-start-menu__item" data-visibility="private">
        <span data-lang="start-tour-visibility-private">${$trans('start-tour-visibility-private')}</span>
      </li>
    `);
  }

  static template() {
    return `<ul class="bagless-dropdown-menu" id="tourStartMenu"></ul>`;
  }
}
